import { useEffect } from "react";

// Injects a JSON-LD <script> into <head> for SEO / AI answer engines.
const JsonLd = ({ data, id }) => {
  useEffect(() => {
    const scriptId = id || `jsonld-${Math.random().toString(36).slice(2)}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(scriptId);
      if (node) node.remove();
    };
  }, [data, id]);

  return null;
};

export default JsonLd;
